import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE = `${u}/trading-strategy`;

const safeList = async (r) => {
  if (!r || !r.ok) return [];
  try { const d = await r.json(); return Array.isArray(d) ? d : []; } catch { return []; }
};

const safeObj = async (r) => {
  if (!r || !r.ok) return null;
  try { return await r.json(); } catch { return null; }
};

export const getStrategies = () =>
  apiFetch(`${BASE}`).then(safeList);

export const createStrategy = (data) =>
  apiFetch(`${BASE}`, { method: "POST", body: JSON.stringify(data) }).then(safeObj);

export const seedStrategies = () =>
  apiFetch(`${BASE}/seed`, { method: "POST" }).then(safeList);

export const updateStrategy = (strategyId, data) =>
  apiFetch(`${BASE}/${strategyId}`, { method: "PUT", body: JSON.stringify(data) }).then(safeObj);

export const deleteStrategy = (strategyId) =>
  apiFetch(`${BASE}/${strategyId}`, { method: "DELETE" });

export const getRules = (strategyId) =>
  apiFetch(`${BASE}/${strategyId}/rules`).then(safeList);

export const addRule = (strategyId, data) =>
  apiFetch(`${BASE}/${strategyId}/rules`, { method: "POST", body: JSON.stringify(data) }).then(safeObj);

export const updateRule = (strategyId, ruleId, data) =>
  apiFetch(`${BASE}/${strategyId}/rules/${ruleId}`, { method: "PUT", body: JSON.stringify(data) }).then(safeObj);

export const deleteRule = (strategyId, ruleId) =>
  apiFetch(`${BASE}/${strategyId}/rules/${ruleId}`, { method: "DELETE" });

export const reorderRules = (strategyId, positions) =>
  apiFetch(`${BASE}/${strategyId}/rules/positions`, {
    method: "PUT", body: JSON.stringify(positions),
  });

export const getAiAnalysis = (symbol, rules = []) =>
  apiFetch(`${BASE}/ai-analysis`, {
    method: "POST", body: JSON.stringify({ symbol, rules }),
  }).then(safeObj);

export const runScreener = () =>
  apiFetch(`${BASE}/screener`).then(safeList);

export const getSignalsForSymbol = (symbol, avgCost) => {
  const qs = avgCost ? `?avgCost=${avgCost}` : "";
  return apiFetch(`${BASE}/signals/${encodeURIComponent(symbol)}${qs}`).then(safeObj);
};

export const getValidationEntries = (strategyId, symbol) => {
  const qs = symbol ? `?symbol=${encodeURIComponent(symbol)}` : "";
  return apiFetch(`${BASE}/${strategyId}/validations${qs}`).then(safeList);
};

export const addValidationEntry = (strategyId, data) =>
  apiFetch(`${BASE}/${strategyId}/validations`, {
    method: "POST", body: JSON.stringify(data),
  }).then(safeObj);

export const deleteValidationEntry = (strategyId, id) =>
  apiFetch(`${BASE}/${strategyId}/validations/${id}`, { method: "DELETE" });

export const updateValidationOutcome = (strategyId, id, outcome) =>
  apiFetch(`${BASE}/${strategyId}/validations/${id}/outcome`, {
    method: "PATCH", body: JSON.stringify({ outcome }),
  }).then(safeObj);

export const linkPaperTrade = (strategyId, entryId, paperTradeId) =>
  apiFetch(`${BASE}/${strategyId}/validations/${entryId}/link-trade`, {
    method: "PATCH", body: JSON.stringify({ paperTradeId }),
  }).then(safeObj);
